import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';

export default css({
  '.video-composition-button': {
    '&__btn': {
      whiteSpace: 'nowrap',
      minWidth: 'unset',
      '& svg': {
        color: COLORS.NEUTRAL500,
      },
    },
  },
});
